import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-12 px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-121">
      <div className="max-w-[680px] mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-5" data-id="element-123">
          <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] text-center mb-6" data-id="element-124">
            El enemigo comenzó a susurrar.
          </h2>

          <div className="space-y-4 text-lg text-[var(--text-primary)] leading-relaxed font-light" data-id="element-125">
            <p data-id="element-126">
              En ese silencio, comenzaron a aparecer pensamientos que tú, en lo
              profundo, ya temías:
            </p>

            <div className="bg-[var(--bg-card)] p-6 rounded-lg border border-[var(--accent)]/15 space-y-3" data-id="element-127">
              <p className="text-lg font-serif text-[var(--text-muted)] italic text-center" data-id="element-128">
                "Quizás Dios no existe."
              </p>
              <p className="text-lg font-serif text-[var(--text-muted)] italic text-center" data-id="element-129">
                "Quizás Él existe, pero tú no le importas."
              </p>
              <p className="text-lg font-serif text-[var(--text-muted)] italic text-center" data-id="element-130">
                "Quizás hiciste algo tan malo que ya no hay regreso."
              </p>
            </div>

            <p data-id="element-131">
              Esos pensamientos te dan vergüenza. No se los has dicho a nadie.
              Ni a tu pastor. Ni a tu familia. Los cargas solo, en silencio,
              mientras finges que "todo está bien" y que "confías en el
              proceso".
            </p>

            <div className="border-l-2 border-[var(--accent)] pl-5 py-2 my-4" data-id="element-132">
              <p className="font-serif italic text-[var(--text-heading)] text-xl" data-id="element-133">
                Pero no estás bien. Y estás agotado de fingir que lo estás.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}